module.exports = __webpack_public_path__ + "img/pickup_logo_cart.svg";